import React from "react";
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import userManager from "../utils/userManager";

class Callback extends React.Component {
    render() {
        return (
            <CallbackComponent
                userManager={userManager}
                successCallback={() => {
                    this.props.history.push('/')
                }}
                errorCallback={error => {
                    this.props.history.push('/');
                    console.error(error);
                }}
            >
                <div className="auth"><div className="loader"><img src="/images/loader.svg" alt="loader"/></div></div>
            </CallbackComponent>
        );
    }
}
export default connect( null, { })(Callback);
